module.exports = __webpack_public_path__ + "static/img/icon.845fa68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/icon.jpg
// module id = 1f75
// module chunks = 0